// src/App.js
import React from 'react';
import { OpenViduProvider } from './contexts/OpenViduContext';
import { JoinSessionForm } from './components/JoinSessionForm';
import { VideoRoom } from './components/VideoRoom';
import { ControlPanel } from './components/ControlPanel';
import { useOpenVidu } from './contexts/OpenViduContext';

const AppContent = () => {
  const { isConnected, error, clearError, isMobile } = useOpenVidu();

  const styles = {
    app: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      height: '100vh',
      overflow: 'hidden',
      background: isConnected ? '#f8f9fa' : 'transparent',
    },
    errorBanner: {
      position: 'fixed',
      top: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#dc3545',
      color: 'white',
      padding: '12px 20px',
      borderRadius: '8px',
      zIndex: 1001,
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      maxWidth: isMobile ? '90vw' : '400px',
    },
    closeButton: {
      background: 'none',
      border: 'none',
      color: 'white',
      fontSize: '18px',
      cursor: 'pointer',
      padding: '0',
      width: '24px',
      height: '24px',
    }
  };

  return (
    <div style={styles.app}>
      {!isConnected ? <JoinSessionForm /> : <VideoRoom />}
      <ControlPanel />
      
      {error && (
        <div style={styles.errorBanner}>
          <span>❌ {error}</span>
          <button 
            onClick={clearError}
            style={styles.closeButton}
            title="Close"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
};

const App = () => {
  return (
    <OpenViduProvider>
      <AppContent />
    </OpenViduProvider>
  );
};

export default App;